import ChannelsListItem from './ChannelsListItem';

export default ChannelsListItem;
